/**
 * Represents a cancellation caused by navigating away
 * before the previous transition has fully resolved.
 */
"use strict";

function Cancellation() {}

module.exports = Cancellation;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/lib/Cancellation.js
 ** module id = 563
 ** module chunks = 0
 **/